import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

const TaskItem = ({ task, index }) => {
  const t = task?.liveTask || task;
  const name = t?.name || '—';
  const workType = t?.workType?.name;
  const status = t?.status;
  const statusLabel = status === 'To Do' ? 'Not started yet' : status;
  return (
    <div className="flex gap-3 items-start">
      <span className="flex-shrink-0 min-w-[1.25rem] w-6 h-6 bg-gray-200 rounded-md flex items-center justify-center text-xs font-bold text-gray-700">
        {index + 1}
      </span>
      <div className="text-sm text-gray-600">
        <span className="font-medium text-gray-800">{name}</span>
        {workType && <span className="text-gray-500 ml-1">({workType})</span>}
        {statusLabel && <span className="text-gray-500 ml-1">({statusLabel})</span>}
      </div>
    </div>
  );
};

const QuickSummary = ({ summary }) => {
  const block = summary?.tomorrowsPlanBlock;
  const rawTasks = block
    ? [...(block.plannedStart || []), ...(block.dependencyFollowOn || []), ...(block.ongoing || [])]
    : [];
  const seenIds = new Set();
  const allTasks = rawTasks.filter((item) => {
    const id = item.liveTask?.id;
    if (id == null) return true;
    if (seenIds.has(id)) return false;
    seenIds.add(id);
    return true;
  });
  const hasBlock = allTasks.length > 0;
  const legacyPlans = summary?.tomorrowsPlan;

  return (
    <div className="bg-white rounded-2xl p-6 shadow-md h-full">
      {/* <div className="flex items-center gap-2 mb-3">
                <Sparkles size={20} className="text-gray-900 fill-current" />
                <h3 className="text-lg font-bold text-gray-900">Quick Summary</h3>
            </div>

            {summary?.text && (
                <p className="text-sm text-gray-700 leading-relaxed mb-6">
                    {summary.text}
                </p>
            )} */}

      <div>
        <div className="flex items-center gap-2 mb-3 text-sm font-bold text-gray-900">
          <ArrowRight size={16} />
          Tomorrow&apos;s Plan
          {block?.date && (
            <span className="text-xs font-normal text-gray-500">
              (
              {new Date(block.date).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              })}
              )
            </span>
          )}
        </div>

        {hasBlock ? (
          <div className="flex flex-col gap-2">
            {allTasks.map((item, index) => (
              <TaskItem key={item.liveTask?.id ?? index} task={item} index={index} />
            ))}
          </div>
        ) : legacyPlans?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {legacyPlans.map((plan, index) => (
              <div key={index} className="flex gap-3 items-start">
                <span className="flex-shrink-0 min-w-[1.25rem] w-6 h-6 bg-gray-200 rounded-md flex items-center justify-center text-xs font-bold text-gray-700">
                  {index + 1}
                </span>
                <span className="text-sm text-gray-600">{plan}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500 italic">No plan for tomorrow.</p>
        )}
      </div>
    </div>
  );
};

export default QuickSummary;
